import selectPrivacyModeEnabled from 'app-components/hooks/privacyMode/selectPrivacyModeEnabled';
import { useCallback } from 'react';
import {
  formatAsCurrencyInternal,
  type FormatAsCurrencyType,
  type FormatAsCurrencyOptionsParam,
} from 'utils/formatters';
import { useAppSelector } from './redux';

export default function useFormatAsCurrency() {
  const privacyModeEnabled = useAppSelector(selectPrivacyModeEnabled);

  return useCallback(
    (...args: Parameters<FormatAsCurrencyType>) => {
      const [value, argsOptions] = args;
      const optionsToUse: Partial<FormatAsCurrencyOptionsParam> = {
        ...argsOptions,
        privacyModeEnabled,
      };

      return formatAsCurrencyInternal(value, optionsToUse);
    },
    [privacyModeEnabled],
  );
}
